/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupContractBrokerDto
 */
export interface GroupContractBrokerDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractBrokerDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractBrokerDto
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractBrokerDto
     */
    brokerName: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractBrokerDto
     */
    brokerEmail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupContractBrokerDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GroupContractBrokerDto
     */
    enabledAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupContractBrokerDto
     */
    disabledAt?: Date;
}

/**
 * Check if a given object implements the GroupContractBrokerDto interface.
 */
export function instanceOfGroupContractBrokerDto(value: object): value is GroupContractBrokerDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('brokerName' in value) || value['brokerName'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('enabledAt' in value) || value['enabledAt'] === undefined) return false;
    return true;
}

export function GroupContractBrokerDtoFromJSON(json: any): GroupContractBrokerDto {
    return GroupContractBrokerDtoFromJSONTyped(json, false);
}

export function GroupContractBrokerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractBrokerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'brokerId': json['brokerId'],
        'brokerName': json['brokerName'],
        'brokerEmail': json['brokerEmail'] == null ? undefined : json['brokerEmail'],
        'isActive': json['isActive'],
        'enabledAt': (new Date(json['enabledAt'])),
        'disabledAt': json['disabledAt'] == null ? undefined : (new Date(json['disabledAt'])),
    };
}

export function GroupContractBrokerDtoToJSON(json: any): GroupContractBrokerDto {
    return GroupContractBrokerDtoToJSONTyped(json, false);
}

export function GroupContractBrokerDtoToJSONTyped(value?: GroupContractBrokerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
        'brokerEmail': value['brokerEmail'],
        'isActive': value['isActive'],
        'enabledAt': ((value['enabledAt']).toISOString()),
        'disabledAt': value['disabledAt'] == null ? undefined : ((value['disabledAt']).toISOString()),
    };
}

